import request from '@/utils/request'

let UsedCarApi = {

  /*救援服务列表*/
  list(data) {
    return request._post('/shop/plus.used_car.Index/index', data);
},
/*添加救援服务*/
add(data) {
    return request._post('/shop/plus.used_car.Index/add', data);
},
/*修改救援服务*/
edit(data) {
    return request._post('/shop/plus.used_car.Index/edit', data);
},
/*删除救援服务*/
del(data) {
    return request._post('/shop/plus.used_car.Index/del', data);
},
/*救援服务详情*/
detail(data) {
  return request._post('/shop/plus.used_car.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.used_car.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.used_car.Setting/getSetting', data, errorback);
    },
    // 审核
 passCanel(data) {
    return request._post('/shop/plus.used_car.Index/passCanel', data);
  },
  editGf(data) {
    return request._post('/shop/plus.used_car.Index/editGf', data);
  },
  getCallLog(data) {
    return request._post('/shop/plus.used_car.Index/getCallLog', data);
  },
}
export default UsedCarApi;



// WEBPACK FOOTER //
// ./src/api/used_car.js